import { Header } from "../components";
import * as components from "../sections";

import styles from "./styles/calculator.module.scss";

export default function () {
  return (
    <>
      {components.LayoutWrapper(
        <>
          <div className={styles.wrapper}>
            {Header()}
            {components.CalculatorSection()}
          </div>
        </>
      )}
    </>
  );
}
